import * as React from 'react'

import { observer } from 'mobx-react'

import { CREATE_FORM_RECORD_ID } from '~/client/src/desktop/views/ProjectSetUp/components/ProjectSetupResourceConfig/constants'
import { FormPropertiesSidebar } from '~/client/src/shared/components/FormPropertiesSidebar'
import { SidePanel } from '~/client/src/shared/components/SidePanel/SidePanel'
import { ResourceTypeId } from '~/client/src/shared/constants/resourceTypes'
import type { ResourceSchema } from '~/client/src/shared/resources/domain/resourceSchema'

interface IProps {
  resourceTypeId: ResourceTypeId
  selectedRecordId: string | null
  onClose: () => void
  resourceSchema: ResourceSchema
}

const FormPropertiesSidebarAdmin: React.FC<IProps> = ({
  resourceTypeId,
  selectedRecordId,
  onClose,
  resourceSchema,
}) => {
  const isCreating = selectedRecordId === CREATE_FORM_RECORD_ID

  return (
    <SidePanel zIndex={999}>
      {isCreating ? (
        <FormPropertiesSidebar
          mode="create"
          resourceTypeId={resourceTypeId}
          onClose={onClose}
          resourceSchema={resourceSchema}
        />
      ) : (
        <FormPropertiesSidebar
          key={selectedRecordId}
          mode="edit"
          templateId={selectedRecordId}
          resourceTypeId={resourceTypeId}
          onClose={onClose}
          resourceSchema={resourceSchema}
        />
      )}
    </SidePanel>
  )
}

export default observer(FormPropertiesSidebarAdmin)
